import { forwardRef } from 'react';
import { Field, Select as GardenSelect } from '@zendeskgarden/react-forms';
import type { FormSelectProps } from './interfaces';
import { useSelect } from './useSelect';

export const Select = forwardRef<HTMLSelectElement, FormSelectProps>(
  (
    {
      id,
      name,
      label,
      hint,
      placeholder = 'Selecione...',
      options,
      value,
      onChange,
      message,
      validation,
      className,
      wrapperClassName,
      error,
      ...rest
    },
    ref
  ) => {
    const { inputId, finalMessage, finalValidation, handleChange } = useSelect({
      id,
      onChange,
      error,
      message,
      validation,
      options,
    });

    return (
      <Field className={wrapperClassName}>
        {label && <Field.Label htmlFor={inputId}>{label}</Field.Label>}
        {hint && <Field.Hint>{hint}</Field.Hint>}

        <GardenSelect
          id={inputId}
          name={name}
          ref={ref}
          className={className}
          value={value}
          onChange={handleChange}
          {...rest}
        >
          {placeholder !== null && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))}
        </GardenSelect>

        {finalMessage && (
          <Field.Message validation={finalValidation}>{finalMessage}</Field.Message>
        )}
      </Field>
    );
  }
);

Select.displayName = 'FormSelect';
export default Select;
